import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { Router, RouterModule } from '@angular/router';
import { PaginationComponent } from '../../../components/pagination/pagination.component';
import { QuestionControlService } from '../../../inputfileds/form_services/question-control.service';
import { CoursesService } from '../../../inputfileds/form_services/courses/courses.service';
import { ApiservicesService } from '../../../Services/Apis/apiservices.service';
import { SelectionModel } from '@angular/cdk/collections';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { PermissionService } from '../../../components/Authentication/services/permission.service';
import { AddcoursesComponent } from '../addcourses/addcourses.component';
import { AddsubjectsComponent } from './addsubjects/addsubjects.component';
import { MatMenuModule } from '@angular/material/menu';
import { MatIconModule } from '@angular/material/icon';
import { ToastService } from '../../../Services/toast/toast.service';
import { UploadDialogComponent } from '../../../components/upload-dialog/upload-dialog.component';
import { TranslateDirective } from '../../../components/Utilites/Directives/translate.directive';

export interface SubjectView {
  index: number;
  id: number;
  subject_name: string;
  subject_code: string;
  medium_name: string;
  department_name: string;
  description: string;
}


@Component({
    selector: 'app-subjects',
    imports: [
        FormsModule,
        MatFormFieldModule,
        MatCheckboxModule,
        MatTableModule,
        RouterModule,
        MatButtonModule,
        MatInputModule,
        ReactiveFormsModule,
        MatProgressSpinnerModule,
        CommonModule,
        PaginationComponent,
        MatIconModule,
        MatMenuModule,
        TranslateDirective
    ],
    providers: [QuestionControlService, CoursesService, ApiservicesService],
    templateUrl: './subjects.component.html',
    styleUrl: './subjects.component.scss'
})

export class SubjectsComponent {

  displayedColumns: string[] = [
    // 'select',
    'subject_name',
    'subject_code',
    'medium_name',
    'description',
    'status',
    'actions',
  ];
  dataSource = new MatTableDataSource<SubjectView>();
  selection = new SelectionModel<SubjectView>(true, []);
  // private apisevice = inject(ApiservicesService)
  lookupdatas: any;
  showaddflag: boolean = false;
  datesend: any;
  subjectList: any
  isLoadingResults = true;
  isRateLimitReached = false;
  total_count: any;
  paginationData: any;
  canCreate: boolean = false;
  canView: boolean = false;
  actiondata: any;

  constructor(
    private apiservice: ApiservicesService,
    private dialog: MatDialog,
    private router: Router,
    private qcs: QuestionControlService,
    private toast: ToastService,
    private permissionService: PermissionService,
    private courseservice: CoursesService
  ) {

   }

  ngOnInit(): void {
    this.actiondata = this.permissionService.getactiondata();
    if (this.actiondata?.view === false) {
      //  delete [this.displayedColumns.indexOf('actions')];
      this.displayedColumns.splice(this.displayedColumns.indexOf('actions'), 1);
    }
    this.getSubjectdetails();
  }

  pagination(event: any) {
    this.paginationData = event;
    this.getSubjectdetails();
  }

  getSubjectdetails() {
    this.apiservice.getsubjectslist(this.paginationData).subscribe((res) => {
      this.subjectList = res.rows
      this.total_count = res.total_count;
      this.dataSource = new MatTableDataSource<SubjectView>(res.rows);
      this.isLoadingResults = false;
      this.isRateLimitReached = res === null;
    });
  }

  openAddSubjectDialog() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.panelClass = ['animate__animated', 'animate__fadeIn']
    dialogConfig.minWidth = '50vw';
    dialogConfig.maxWidth = '60vw';
    dialogConfig.minHeight = '65vh';
    dialogConfig.maxHeight = '65vh';
    dialogConfig.data = { total_count: this.total_count };
    const dialogRef = this.dialog.open(AddsubjectsComponent, dialogConfig);

    dialogRef.afterClosed().subscribe(result => {
      // if (result) {
      this.getSubjectdetails();
      // }
    });
  }
  /** Whether the number of selected elements matches the total number of rows. */
  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.data.length;
    return numSelected === numRows;
  }
  /** Selects all rows if they are not all selected; otherwise clear selection. */
  toggleAllRows() {
    if (this.isAllSelected()) {
      this.selection.clear();
      return;
    }
    this.selection.select(...this.dataSource.data);
  }

  /** The label for the checkbox on the passed row */
  checkboxLabel(row?: SubjectView): string {
    if (!row) {
      return `${this.isAllSelected() ? 'deselect' : 'select'} all`;
    }
    return `${this.selection.isSelected(row) ? 'deselect' : 'select'} row ${row.index + 1
      }`;
  }

  // To show the semester page
  showsemesterdetails(id: any) {
    // const filteredData = this.subjectList.filter((item: any) => item.id === parseInt(id));
    this.router.navigate(['subjects/semesterdetails'], { queryParams: { data: id.id } });
  }

  actionrequestapi(status: string, id: number) {
    let apidata = {
      status: status
    }
    this.apiservice.update_subject_status(apidata, id).subscribe((res: any) => {
      if (res.code == 204 && res.status == true) {
        this.toast.showToast('success', `Successfully created`);
        this.getSubjectdetails();
      }
      else {
        this.toast.showToast('danger', `Error: ${res.message}`);
      }
    });
  }

  openUploadDialog(uploadType: 'details' | 'images', formDataKey: 'subjectImages' | 'SUBJECTS_BULKUPLOAD_TEMPLATE'): void {
    let excelallowedFileTypes = ['application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'];
    let zipallowedFileTypes = ['application/zip', 'application/x-zip-compressed'];
    let allowedFileTypes;
    if (formDataKey == 'SUBJECTS_BULKUPLOAD_TEMPLATE') {
      allowedFileTypes = excelallowedFileTypes
    } else {
      allowedFileTypes = zipallowedFileTypes
    }
    const dialogRef = this.dialog.open(UploadDialogComponent, {
      data: { uploadType, formDataKey, allowedFileTypes }
    });
    dialogRef.afterClosed().subscribe(result => {
      this.getSubjectdetails();
    });
  }
}
